import React from "react";
import HomePage from "pages/PublicView/HomePage/HomePage";
import useAppContext, { ACCOUNT_TYPES } from "state/AppContext";
import AdminDashboardPage from "pages/AdminView/AdminDashboardPage/AdminDashboardPage";
import RecruiterDashboardPage from "pages/RecruitersView/RecruiterDashboardPage/RecruiterDashboardPage";
import ClientDashboardPage from "pages/ClientView/ClientDashboardPage/ClientDashboardPage";

export default function RootSwitch() {
  const appContext = useAppContext();
  const { accountType, isAuthenticated } = appContext.account;
  const { type } = accountType;

  if (!isAuthenticated) {
    return <HomePage />;
  } else if (type === ACCOUNT_TYPES.ADMIN.type) {
    return <AdminDashboardPage />;
  } else if (type === ACCOUNT_TYPES.RECRUITER.type) {
    return <RecruiterDashboardPage />;
  } else if (type === ACCOUNT_TYPES.EMPLOYER_PRIVATE.type) {
    return <ClientDashboardPage />;
  } else {
    return <HomePage />;
  }
}
